import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 20v-5c0 -6.075 4.925 -11 11 -11h5","key":"svg-0"}]]

/**
 * IconBorderCornerPill
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYm9yZGVyLWNvcm5lci1waWxsIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik00IDIwdi01YzAgLTYuMDc1IDQuOTI1IC0xMSAxMSAtMTFoNSIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/border-corner-pill
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBorderCornerPill = createReactComponent('outline', 'border-corner-pill', 'BorderCornerPill', __iconNode);

export default IconBorderCornerPill;